<template>
  <div>
    <br/>
    <SelectOptionPeriodRent
        :rentId="rentId"
        :type="type"
        :showPeriodAll="false"
    />
    <br/>
    <Molded>
      <ProductAdd
          :rentId="rentId"
          :statusPatrimony="statusPatrimony"
      />
    </Molded>
    <br/>
    <b-row>
      <b-col sm="6">
        <ProductRent
            :title="titleProductRent"
        />
      </b-col>
      <b-col sm="6">
        <ProductSelected
            :title="titleProductSelected"
            :type="type"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>

import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import ProductAdd from "./ProductAdd.vue";
import SelectOptionPeriodRent from "../../rental/period-rental/SelectOptionPeriodRent.vue";
import ProductRent from "./ProductRent.vue";
import ProductSelected from "./ProductSelected.vue";

import {mapState} from "vuex";

export default {
  name: "RentAndSelected",
  props: {
    rentId: String,
    statusPatrimony: Number,
    titleProductRent: String,
    titleProductSelected: String,
  },
  computed: {
    ...mapState("generateMoviment", ["type"]),
  },
  components: {
    SelectOptionPeriodRent,
    ProductRent,
    Molded,
    ProductSelected,
    ProductAdd,
  },
};
</script>
